const CATEGORIES_ACTION_TYPES = {
  SET_CATEGORIES: 'categories/SET_CATEGORIES',
};

export default CATEGORIES_ACTION_TYPES;